"use client";

import React, { useState } from 'react';
import ExteriorView from './ExteriorView';
import InteriorView from './InteriorView';

export default function ExteriorInteriorSection({ car }) {
  const [activeTab, setActiveTab] = useState('exterior'); // 'exterior' or 'interior'

  return (
    <div className="w-full max-w-[1700px] mx-auto py-8 md:py-16">

      {/* Section Header */}
      <div className="text-center md:text-right mb-6 md:mb-10 px-4 md:px-0">

        {/* Toggle Tabs */}
        <div className="inline-flex bg-gray-100 rounded-small-button-mob md:rounded-small-button-desk p-1 shadow-inner border border-gray-200" dir="rtl">
          <button
            onClick={() => setActiveTab('exterior')}
            className={`px-8 py-3 rounded-small-button-mob md:rounded-small-button-desk text-sm font-semibold transition-all ${activeTab === 'exterior'
              ? 'bg-white text-gray-900 shadow-md'
              : 'bg-transparent text-gray-500 hover:text-gray-700'
              }`}
          >
            نمای بیرونی
          </button>
          <button
            onClick={() => setActiveTab('interior')}
            className={`px-8 py-3 rounded-small-button-mob md:rounded-small-button-desk text-sm font-semibold transition-all ${activeTab === 'interior'
              ? 'bg-white text-gray-900 shadow-md'
              : 'bg-transparent text-gray-500 hover:text-gray-700'
              }`}
          >
            نمای داخلی
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {/* On mobile: negative margin pulls it out of parent padding to leave exactly 4px margin on screen edges. p-1 adds 4px padding inside. */}
      <div className="bg-white rounded-2xl md:rounded-card-desk shadow-sm border border-gray-100 p-1 md:p-10 -mx-3 md:mx-0 min-h-[400px] md:min-h-[600px] flex flex-col items-center justify-center">
        <div className={`w-full ${activeTab === 'exterior' ? 'block' : 'hidden'}`}>
          <ExteriorView car={car} />
        </div>
        <div className={`w-full ${activeTab === 'interior' ? 'block' : 'hidden'}`}>
          <InteriorView car={car} />
        </div>
      </div>

    </div>
  );
}
